import { InfoBox } from '@/components';

export interface InfoBoxProps {
  intent?: 'primary' | 'secondary';
  title?: string;
  children: React.ReactNode;
  link?: {
    to: string;
    text: string;
  };
}

export const WhenAreCampaignsPaidOut = () => {
  return (
    <InfoBox
      title="When are campaigns paid out?"
      link={{
        to: 'https://learn.acast.com/en/articles/5146617-how-and-when-will-i-get-paid',
        text: 'Learn more about when earnings get paid',
      }}
    >
      <ul role="list" className="list-disc list-outside pl-4 my-2">
        <li>
          <strong>Most campaign types</strong> are ready for payout in the{' '}
          <strong>month after they generate earnings</strong>, although some specific campaigns may
          have different timelines.{' '}
        </li>
        <li>
          <strong>Programmatic</strong> campaigns are ready for payout{' '}
          <strong>after two months</strong> due to the need for additional verification. For
          example, Programmatic earnings from January might appear on your statements in March or
          April.
        </li>
      </ul>
    </InfoBox>
  );
};

export const WhatIsTheDifferenceBetweenCampaignTypes = () => {
  return (
    <InfoBox
      intent="secondary"
      title="What is the difference between campaign types?"
      link={{
        to: 'https://learn.acast.com/en/articles/11419220-campaign-types',
        text: 'Learn more about campaign types',
      }}
    >
      <ul role="list" className="list-disc list-outside pl-4 my-2">
        <li>
          Some categories, such as ads and programmatic, require little to no action from you to
          generate revenue and are controlled by your ad settings and blocklist.
        </li>
        <li>
          Others, which may represent a larger revenue source, require your direct approval and
          involvement in producing assets through AdCollab.
        </li>
      </ul>
    </InfoBox>
  );
};
